import { ImportOutlined } from '@ant-design/icons';
import { Avatar, Button, Card } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MrssImportCard.css';

const { Meta } = Card;

const MrssImportCard: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Card hoverable className="custom-card" style={{ width: '100%', marginBottom: '16px' }}>
      <div className="card-content">
        <Meta
          avatar={
            <Avatar
              size={48}
              style={{ backgroundColor: '#f6f6f6' }}
              icon={<ImportOutlined style={{ color: 'black' }} />}
            />
          }
          title={<span className="upload-description">{'MRSS'}</span>}
        />
        <div className="buttons-container">
          {
            <>
              <Button onClick={() => navigate('/video-source/add')}>Add Mrss Source</Button>
              <Button onClick={() => navigate('/video-source')}>Manage Video Source</Button>
              <Button
                onClick={() =>
                  navigate('/video-source/content', {
                    state: { videoSourceType: 'cp' },
                  })
                }
              >
                Manage Import vidoes
              </Button>
            </>
          }
        </div>
      </div>
    </Card>
  );
};

export default MrssImportCard;
